import Axios from 'axios';
import { Config } from '../apiRoutes';

// Both thunks return the Axios promise directly - message lists are
// one-shot data held in component state, not the redux store.
export const getAppMessages = (signedPayload) => {
  return () => {
    let endPoint = Config.baseUrl + Config.appMessages;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers });
  }
}

export const dismissAppMessage = (signedPayload, messageId) => {
  return () => {
    let endPoint = `${Config.baseUrl}${Config.appMessageDismiss}${messageId}/dismiss`;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, {}, { headers: headers });
  }
}
